export default (t: string => string) => ({
  advisorType: {
    "ui:widget": "hidden",
  },
  blockConsent: {
    "ui:widget": "toggle",
    "ui:options": {
      statusBadge: true,
      labels: [
        { label: t("ACTIVE"), value: true },
        { label: t("INACTIVE"), value: false },
      ],
      tooltip: {
        description: t("CLIENT_CONSENT_TOOLTIP"),
        id: "client-consent-block",
      },
    },
  },
  fcaBlock: {
    "ui:widget": "hidden",
  },
  homeWorkingBlock: {
    "ui:widget": "hidden",
  },
  aggregatedBenchmark: {
    "ui:widget": "hidden",
  },
  eapSignposting: {
    "ui:widget": "switch-button",
    "ui:options": {
      label: t("SERVICES_HUB"),
      description: t("CLIENT_SERVICE_HUB_DESCRIPTION"),
    },
  },
  absenceMonitoring: {
    "ui:widget": "switch-button",
    "ui:options": {
      label: t("MONITOR"),
      description: t("CLIENT_MONITOR_DESCRIPTION"),
    },
  },
  referralTracking: {
    "ui:widget": "switch-button",
    "ui:options": {
      label: t("NAVIGATOR"),
      description: t("CLIENT_NAVIGATOR_DESCRIPTION"),
    },
  },
  developerApiAccess: {
    "ui:widget": "switch-button",
    "ui:options": {
      label: t("DEVELOPER"),
      description: t("CLIENT_DEVELOPER_DESCRIPTION"),
    },
  },
  dataForecastingAccess: {
    "ui:widget": "switch-button",
    "ui:options": {
      label: t("FORECAST"),
      description: t("CLIENT_FORECAST_DESCRIPTION"),
    },
  },
  mobileAppAccess: {
    "ui:widget": "switch-button",
    "ui:options": {
      label: t("MOBILE_APP"),
      description: t("CLIENT_MOBILE_APP_DESCRIPTION"),
    },
  },
  nurseTransferType: {
    "ui:widget": "hidden",
  },
  overflowSupport: {
    "ui:options": {
      label: t("OVERFLOW"),
      tooltip: {
        description: t("CLIENT_OVERFLOW_TOOLTIP"),
        id: "client-oveflow",
      },
    },
  },
  absenceLineNumber: {
    "ui:options": {
      tooltip: {
        description: t("CLIENT_ABSENCE_LINE_TOOLTIP"),
        id: "client-absence-line",
      },
    },
  },
  emailAddress: {
    "ui:options": {
      tooltip: {
        description: t("CLIENT_EMAIL_TOOLTIP"),
        id: "client-email-address",
      },
    },
  },
  "ui:order": [
    "absenceMonitoring",
    "referralTracking",
    "dataForecastingAccess",
    "developerApiAccess",
    "mobileAppAccess",
    "eapSignposting",
    "*",
  ],
});
